
import url from 'c-url';
import lang from '../lang/index';

let channel = url.query('channel');

let configMap = {
    mycard: {
        text: lang.template('MyCard充值'),
        option: 'bj_mycard'
    },
    bank: {
        text: lang.template('银行汇款'),
        option: 'sinopac_atm'
    },
    paypal: {
        text: lang.template('PayPal充值'),
        option: 'paypal'
    },
    bk_card: {
        text: lang.template('bk_card支付'),
        option: 'bk_card'
    },
    bk_atm: {
        text: lang.template('bk_atm支付'),
        option: 'bk_atm'
    },
    onecard: {
        text: lang.template('onecard支付'),
        option: 'onecard'
    },
    // 马来西亚本地支付
    xenopay: {
        text: lang.template('Xenopay充值'),
        option: 'xenopay'
    },

    // 泰国cashcard
    cashcard_thb: {
        text: lang.template('CashCard(THB)'),
        option: 'pepay_entitycard_thb'
    },

    // 印尼cashcard
    // cashcard_idr: {
    //     text: lang.template('CashCard(IDR)'),
    //     option: 'pepay_entitycard_idr'
    // },

    // onlinebank_idr: {
    //     text: lang.template('OnlineBank(IDR)'),
    //     option: 'pepay_onlinebank_idr'
    // },

    // cashu: {
    //     text: lang.template('cashu支付'),
    //     option: 'cashu'
    // },
    twrecharge: {
        mycard: {

        },
        bank: {

        }

    },
    // 印尼充值方式
    pepay_alfamart_idr: {
        text: lang.template('Alfamart充值'),
        option: 'pepay_alfamart_idr'
    },
    pepay_webatm_idr: {
        text: lang.template('pepay_webatm_idr充值'),
        option: 'pepay_webatm_idr'
    },
    codapay: {
        text: lang.template('Codapay充值'),
        option: 'codapay'
    },
    // 仅限巴基斯坦用
    molpay_points: {
        text: lang.template('molpay_points'),
        option: 'molpay_points'
    },
    //  新增的两种印度充值方式
    // molpay_points: {
    //     text: lang.template('molpay_points'),
    //     option: 'molpay_points'
    // },
    // molpay_credit_card: {
    //     text: lang.template('molpay_credit_card'),
    //     option: 'molpay_credit_card'
    // }
    
    paytm: {
        text: lang.template('paytm'),
        option: 'paytm'
    },
    pepay_onlinebank_vnd:{
        text:lang.template('pepay_onlinebank'),
        option:'pepay_onlinebank_vnd'
    },
    pepay_entitycard_vnd:{
        text:lang.template('pepay_entitycard'),
        option:'pepay_entitycard_vnd'
    },
    //印尼充值方式
    codapay_id:{
        text:lang.template('Direct Carrier Billing'),
        option:'codapay_1'
    },
    codapay_id_1:{
        text:lang.template('Direct Carrier Billing'),
        option:'codapay_1'
    },
    codapay_id_220:{
        text:lang.template('ATM Transfer'),
        option:'codapay_220'
    },
    codapay_id_221:{
        text:lang.template('Alfamart'),
        option:'codapay_221'
    },
    codapay_id_223:{
        text:lang.template('Doku Wallet'),
        option:'codapay_223'
    },
    codapay_id_224:{
        text:lang.template('7-Eleven'),
        option:'codapay_224'
    },
    codapay_id_226:{
        text:lang.template('Indomaret'),
        option:'codapay_226'
    },
    codapay_id_227:{
        text:lang.template('GO-PAY'),
        option:'codapay_227'
    },
    //菲律宾充值方式
    codapay_ph:{
        text:lang.template('Bank Payments'),
        option:'codapay_250'
    },
    codapay_ph_250:{
        text:lang.template('Bank Payments'),
        option:'codapay_250'
    },
    codapay_ph_251:{
        text:lang.template('Counter Payments'),
        option:'codapay_251'
    },
    codapay_ph_252:{
        text:lang.template('GCash'),
        option:'codapay_252'
    },
    codapay_ph_253:{
        text:lang.template('7-Eleven PH'),
        option:'codapay_253'
    },
    //越南充值方式
    codapay_vn:{
        text:lang.template('MoMo'),
        option:'codapay_351'
    },
    codapay_vn_351:{
        text:lang.template('MoMo'),
        option:'codapay_351'
    },
    icard: {
        text: lang.template('iCard '),
        option: 'icard'
    },
    kakaopay: {
        text: lang.template('Kakao pay'),
        option: 'kakaopay'
    },
    paystack: {
        text: lang.template('paystack'),
        option: 'paystack'
    },
    sslcommerz: {
        text: lang.template('SSL'),
        option: 'sslcommerz'
    },
    gash: {
        text: lang.template('gash'),
        option: 'gash'
    },
    gash_card: {
        text: lang.template('gash card'),
        option: 'gash_card'
    },
    // 印度
    codapay_390: {
        text: lang.template('Paytm Wallet'),
        option: 'codapay_390'
    },
    codapay_391: {
        text: lang.template('Bank Transfer'),
        option: 'codapay_391'
    },

    dokypay: {
        text: lang.template('DokyPay'),
        option: 'dokypay'
    }
};

configMap.twrecharge = {
    mycard: configMap.mycard,
    bank: configMap.bank
}


let switchChannelTw = (_channel)=>{
    if (channel != 'twrecharge') {
        return;
    }
    config.text = configMap['twrecharge'][_channel].text;
    config.option = configMap['twrecharge'][_channel].option;
}

channel = channel == 'codapay'? 'codapay_id_1' : channel;

let config = configMap[channel] || configMap['paypal'];

export default config;

export {
    configMap,
    switchChannelTw
};




// WEBPACK FOOTER //
// ./js/global/channel-config.js